import { render, staticRenderFns } from "./MedalManage.vue?vue&type=template&id=7e8da452&scoped=true"
import script from "./MedalManage.vue?vue&type=script&lang=js"
export * from "./MedalManage.vue?vue&type=script&lang=js"
import style0 from "./MedalManage.vue?vue&type=style&index=0&id=7e8da452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8da452",
  null
  
)

export default component.exports